import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../authentication.service';
import { SubscriptionService } from '../../../services/subscription.service';
import { HelpService } from '../../../services/help.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { openModal, closeModal } from '../../../shared/modal-functions';
import { responseIsSuccess } from '../../../shared/helper-functions';
import { arrayIsDefinedAndContainsKey } from '../../../shared/array-functions';
import { getCurrentDateForView } from '../../../shared/date-functions';
import { complaintsView } from './complaints.static.data';

@Component({
  selector: 'app-complaints',
  templateUrl: './complaints.component.html',
  styleUrls: ['../../../app.component.css']  
})
export class ComplaintsComponent implements OnInit {
  // Static data
  complaintsView: any;
  // Control view
  openModal: any;
  closeModal: any;
  // User data
  printSubscriptions: object[];
  selectedSubscription: object;
  selectedSubscriptionToShowComplaint: object;
  newComplaintReasonId: number;
  lastSubmittedComplaint: object;
  currentDate: string;

  constructor(public authenticationService: AuthenticationService, public subscriptionService: SubscriptionService, public helpService: HelpService, public googleAnalyticsService: GoogleAnalyticsService) { 
    this.complaintsView = complaintsView;
    this.openModal = openModal;
    this.closeModal = closeModal;
    this.selectedSubscription = {};
    this.currentDate = getCurrentDateForView();
    this.selectedSubscription = this.subscriptionService.printSubscriptions[0];
    this.helpService.getLastSubmittedComplaint(this.authenticationService.gigyaId);
    !this.helpService.reasons ? this.helpService.getComplaintReasons() : '';
  }

  ngOnInit() {
  }

  submitNewComplaint() {
    this.helpService.addNewComplaint(this.selectedSubscription['SubID'], this.newComplaintReasonId, this.authenticationService.gigyaId).subscribe(
      (response) => {
        this.newComplaintReasonId = undefined;
        this.closeModal('#submitNewComplaintModal');
        if (responseIsSuccess(response) && arrayIsDefinedAndContainsKey(response, 'CMS_IssueComplaintProcess') && response['CMS_IssueComplaintProcess'][0]['SubmitedComplaint'] === 'True') {
          this.openModal('#successResponseModal'); // hourDiff > 1 AND amountComplaint <2
          this.submitGAEvent('Ayuda_SAM', 'Click', 'Pantalla_Confirmando_Envio');
        } else if (responseIsSuccess(response) && arrayIsDefinedAndContainsKey(response, 'CMS_IssueComplaintProcess') && response['CMS_IssueComplaintProcess'][0]['SubmitedComplaint'] === 'NoIssue') {
          this.openModal('#errorNoIssueResponseModal');
          this.submitGAEvent('Ayuda_SAM', 'Click', 'Pantalla_Confirmando_Error_Fuera_de_Fecha');
        } else if (responseIsSuccess(response) && arrayIsDefinedAndContainsKey(response, 'CMS_IssueComplaintProcess') && response['CMS_IssueComplaintProcess'][0]['SubmitedComplaint'] === 'MAXISSUE') {
          this.openModal('#errorMaxIssueResponseModal'); // hourDiff < 1 OR amountComplaint > = 2
          this.submitGAEvent('Ayuda_SAM', 'Click', 'Pantalla_Confirmando_Error_Maximo_Permitido');
        } else {
          this.openModal('#errorNewComplaintResponseModal');
        }
    });
  }

  selectSubscriptionForComplaint(subscription) {
    this.selectedSubscription = subscription;
  }

  selectSubscriptionToShowComplaint(subscription) {
    this.lastSubmittedComplaint = undefined;
    this.selectedSubscriptionToShowComplaint = subscription;
    if (subscription.Complaints && subscription.Complaints.length !== 0) {
      this.lastSubmittedComplaint = subscription['Complaints'][0];
    }
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/complaints/complaints.component.ts